import React from 'react';
import { useTranslation } from 'react-i18next';

const SUPPORT_EMAIL = 'hallo@seller2go.com';

const SidebarHelp: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="sidebar-help">
      <p className="sidebar-help-text">{t('sidebar_help_text')}</p>
      <a
        className="btn btn-secondary sidebar-help-btn"
        href={`mailto:${SUPPORT_EMAIL}`}
      >
        {t('sidebar_help_button')}
      </a>
    </div>
  );
};

export default SidebarHelp;
